import { useEffect } from "react";
import "./App.css";
import AppRoutes from "./AppRoutes";
import Header from "./components/Header";
import i18n from "./translation/i18n";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Footer from "./components/Footer";
import NationalDayAudio from "./components/NationalDayAudio";
import "preline/preline";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import OverLayVideo from "./components/OverLayVideo";
import { getSiteTheme } from "./api/getSiteTheme";
import "./theme/themes.css";
import {
  applyTheme,
  applyCachedTheme,
  cacheTheme,
  getPreviewTemplate,
} from "./theme/applyTheme";

// A ?preview_template=slug URL (admin live preview) always wins and is never
// cached. Otherwise apply the previously cached template immediately (before
// first paint) to avoid a flash of the wrong palette while the request is in
// flight.
const previewTemplate = getPreviewTemplate();
if (previewTemplate) {
  applyTheme(previewTemplate, true);
} else {
  applyCachedTheme();
}

function App() {
  const { t } = useTranslation();
  const lng = useSelector(function (state) {
    return state.lang.value;
  });

  const vid = useSelector(function (state) {
    return state.video;
  });

  useEffect(
    function () {
      window.document.dir = i18n.dir(lng);
      window.document.documentElement.lang = lng;
      document.title = t("SiteName");
      if (lng && i18n.resolvedLanguage !== lng) {
        i18n.changeLanguage(lng);
      }
    },
    [lng, t]
  );
  const location = useLocation();
  useEffect(
    function () {
      window.HSStaticMethods.autoInit();
    },
    [location.pathname]
  );

  useEffect(() => {
    AOS.init();
  }, [location]);

  useEffect(() => {
    // In preview mode the URL decides the template; skip the settings fetch
    // so the previewed design cannot be overridden or cached.
    if (previewTemplate) return;
    let active = true;
    getSiteTheme()
      .then(({ enabled, template }) => {
        if (!active) return;
        applyTheme(template, enabled);
        cacheTheme(enabled, template);
      })
      .catch(() => {
        // On failure keep the default design.
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className={`appbg ${lng === "en" ? "font-inter" : "alexandria"}`}>
      {vid.clicked === "yes" ? (
        <OverLayVideo />
      ) : (
        <div className="fixed hidden inset-0 w-0 h-0 duration-500 transition-all"></div>
      )}
      <Header />
      <AppRoutes />
      <Footer />
      <NationalDayAudio />
    </div>
  );
}

export default App;
